// @flow
import type { Region } from '~/core/types/devices';
import type { Filter } from '../../../types';
import * as React from 'react';
import { find, get } from 'lodash/fp';
import { FormattedMessage } from 'react-intl';
import actionMessages from '~/core/constants/actions/intl';
import messages from './intl';

import { categories, getFilterDevicesList } from '~/core/constants/actions/index';

const BUILD_YOUR_OWN = 'BUILD_YOUR_OWN';
const BY_DEVICE = 'BY_DEVICE';
const SHOW_ALL = 'SHOW_ALL';
const WELCOME_HOME = 'WELCOME_HOME';

type Props = {
    currentFilter: Filter,
    productTypesUserOwns: Array<string>,
    region: Region
};

const FilterTitle = ({ currentFilter, productTypesUserOwns, region }: Props) => {
    if (currentFilter.name === SHOW_ALL) {
        return <FormattedMessage {...messages.titleChooseAction} />;
    }

    if (currentFilter.name === BUILD_YOUR_OWN) {
        return <FormattedMessage {...messages.buildYourOwnActions} />;
    }

    if (currentFilter.name !== WELCOME_HOME) {
        const filterItems =
            currentFilter.name === BY_DEVICE ? getFilterDevicesList(region, productTypesUserOwns) : categories;
        const findFilterItem = find(x => x.id === currentFilter.selectedItem);
        const filteredItem = findFilterItem(filterItems);

        const filterItemId = get(['id'], filteredItem);
        const edgeCaseItems = new Map([
            [filterItemId === 'motion-sensor', actionMessages.motionAttribute],
            [filterItemId === 'contact-sensor', actionMessages.winDoorAttribute]
        ]).get(true);

        const filterItemMessage = edgeCaseItems || get(['text'], filteredItem);

        return (
            <FormattedMessage {...filterItemMessage}>
                {filterName => (
                    <FormattedMessage {...messages.titleSpecificTemplates} values={{ selected: filterName }} />
                )}
            </FormattedMessage>
        );
    }
};

export default FilterTitle;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/discover-actions/filter-title/index.js